<footer>
  <kp-modal-policies policyText="Privacy Policy" [policyType]="legalDocumentType.PRIVACY"></kp-modal-policies>
  <kp-modal-policies policyText="Acceptable Use Policy" [policyType]="legalDocumentType.EULA"></kp-modal-policies>
  <kp-copyright
    class="copyright"
    [includeProMedica]="includeProMedica"
    [includeKumanuTrademark]="includeTrademark"></kp-copyright>
</footer>
